import * as ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { initLocalDbs } from './services/DBService/DbService';
import '@app/common/src/styles/tokens.css';

function startApp() {
    ReactDOM.render(
        <Provider store={store}>
            <App />
        </Provider>,
        document.getElementById('root') as HTMLElement
    );
    registerServiceWorker();
}

if (window.cordova) {
    document.addEventListener('deviceready', () => {
        initLocalDbs();
        startApp();
    }, false);
} else {
    initLocalDbs();
    startApp();
}